import { CardMembership, ContactMail, History } from "@material-ui/icons";
import CustomTabs from "components/custom/CustomTabs/CustomTabs";
import { useState } from "react";
import React from "react";
import CustomerInfo from "./CustomerInfo";
import CustomerBookingHistory from "./CustomerBookingHistory";


const CustomerDetails = (props) => {

    const { customerId } = props.match.params;

    const [activeSection, setActiveSection] = useState(0);

    return (
        <>
            <CustomTabs
                headerColor="rose"
                title=""
                value={activeSection}
                changeValue={(e, activeSection) => setActiveSection(activeSection)}
                tabs={[
                    {
                        tabName: 'Customer Details',
                        tabIcon: ContactMail,
                        tabContent: (
                            <CustomerInfo customerId={customerId} />
                        )
                    },
                    {
                        tabName: 'Booking History',
                        tabIcon: History,
                        tabContent: (
                            <CustomerBookingHistory customerId={customerId} />
                        )
                    }
                ]}
            />
        </>
    )
}

export default CustomerDetails;




